module.exports = __webpack_public_path__ + "static/media/AcomplamientoJM2Baldor.66b67303.png";